import { Component, OnInit, ViewChild } from '@angular/core';
import { IonInfiniteScroll, ActionSheetController, IonContent } from '@ionic/angular';
import { AirportListService } from '../../../services/airport/airport-list.service';
import { RetailService } from '../../../services/retail/retail.service';
import { ActionSheetButton } from '@ionic/core';
import { I18ConfigService } from 'src/app/services/shared/I18-config.service';
import { SeoService } from 'src/app/services/seo.service';


@Component({
  selector: 'app-retail',
  templateUrl: './retail.page.html',
  styleUrls: ['./retail.page.scss'],
})
export class RetailPage implements OnInit {
  categoryList: any[];
  storeList: any[] = [];
  selectedCat: string;
  page = 1;
  airportCode: string;
  location = 'Across Airport';
  actionSheetButtonList: ActionSheetButton[] | null = null;

  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  @ViewChild('scrollArea') scrollArea: IonContent;

  noData = 0;
  // tslint:disable-next-line: max-line-length
  constructor(private seoService: SeoService, private actionSheetController: ActionSheetController, private retailApiService: RetailService, private airportService: AirportListService, private i18Config: I18ConfigService) {
    this.seoService.updatePageTitle('home|retail');
  }
  ngOnInit() {
  }
  ionViewDidEnter() {
    this.page = 1;
    this.retailApiService.initApiParams();
    this.airportService.selectedAirport.subscribe(airportCode => {
      this.page = 1;
      this.location = 'Across Airport';
      this.airportCode = airportCode;
      this.retailApiService.initApiParams();
      this.getStoreData();
    });
    this.i18Config.selectedLanguage.subscribe(langCode => {
      this.retailApiService.apiParams.lang = langCode;
      this.getStoreData();
    });
    this.getStoreData();
  }

  initStoreList() {
    this.actionSheetButtonList = null;
    // this.categoryList = [];
    this.noData = 0;
    this.storeList = null;
  }
  private getStoreData() {
    this.airportCode = this.airportCode || this.airportService.getSelectedAirport();
    if (this.airportCode) {
      this.initStoreList();
      this.retailApiService.getAllStores(this.airportCode, this.page).subscribe(response => {
        this.updateRetailPageState(response.products, response);
/*         this.storeList = response.products;
        this.categoryList = response.catList.categories;
 */      });
    }
  }

  async openLocationSheet() {
    const actionSheetButton: ActionSheetButton = {
      text: 'Close',
      role: 'cancel',
    };
    this.actionSheetButtonList.push(actionSheetButton);
    const actionSheet = await this.actionSheetController.create({
      header: 'Filter By Location',
      // mode: 'ios',
      buttons: this.actionSheetButtonList
    });
    await actionSheet.present();

  }
  filterDataByCat(catObject) {
    if (this.selectedCat !== catObject.menu_slug) {
      this.selectedCat = catObject.menu_slug;
    } else {
      this.selectedCat = '';
    }
    this.page = 1;
    if (this.infiniteScroll && this.infiniteScroll.disabled) {
      this.infiniteScroll.disabled = false;
    }
    this.initStoreList();
    this.retailApiService.filterDataByCategory(this.selectedCat).subscribe(response => {
      this.updateRetailPageState(response.products, response);
    });
  }
  private filterDataByLocation(location: string) {
    if (this.location !== location) {
      this.page = 1;
      this.location = location;
      if (this.infiniteScroll && this.infiniteScroll.disabled) {
        this.infiniteScroll.disabled = false;
      }
      this.initStoreList();

      this.retailApiService.filterDataByLocation(location, this.page).subscribe(response => {
        this.updateRetailPageState(response.products, response);
      });
    }

  }
  getNextPage(event) {
    let totalStoreCount: number;
    this.page++;
    this.retailApiService.getAllStores(this.airportCode, this.page).subscribe(response => {
      this.updateRetailPageState(this.storeList.concat(response.products), response);
      totalStoreCount = response.totalCount;
      event.target.complete();
      if (this.storeList.length === totalStoreCount) {
        event.target.disabled = true;
      } else {
        event.target.disabled = false;
      }
    });
  }

  private updateRetailPageState(storeListData: any[], responseObj: any) {
    if (!storeListData || storeListData.length === 0) {
      // this.categoryList = responseObj.catList.categories || [];
      this.noData = 1;
      return;
    }
    if (storeListData.length < this.retailApiService.apiParams.perpage) {
      if (this.infiniteScroll && !this.infiniteScroll.disabled) {
        this.infiniteScroll.disabled = true;
      }
    }
    this.storeList = storeListData;
    this.categoryList = responseObj.catList.categories;
    if (this.page === 1 && responseObj.locations && responseObj.locations.length > 0) {
      this.actionSheetButtonList = [];
      responseObj.locations.sort().forEach(element => {
        const obj = {
          text: element,
          role: '',
          handler: () => {
            this.filterDataByLocation(element);
          }
        };
        if (this.location === element) {
          obj.role = 'selected';
        }
        let actionSheetButton: ActionSheetButton;
        actionSheetButton = obj;
        this.actionSheetButtonList.push(actionSheetButton);
      });
    }
  }

}
